/**
 * Header Layout
 *
 * @file header.js
 */


const header = (() => {
  let lastScrollTop = 0;
  let isHeaderFixed = false;
  let isInitialized = false; // Guard against double init in production

  const fixedHeader = () => {
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    
    if (!header) return;

    // Scroll event listener
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
      
      // Header'ı sabit yapmak için threshold değeri (örn: 100px)
      const threshold = 116;
      
      if (scrollTop > threshold) {
        if (!isHeaderFixed) {
          header.classList.add('header--fixed');
          document.body.style.paddingTop = `${headerHeight}px`;
          isHeaderFixed = true;
        }
        
        // Scroll yönüne göre header'ı göster/gizle
        // if (scrollDirection === 'down' && scrollTop > lastScrollTop + 10) {
        //   // Aşağı scroll - header'ı gizle
        //   header.classList.add('header--hidden');
        // } else if (scrollDirection === 'up' && scrollTop < lastScrollTop - 10) {
        //   // Yukarı scroll - header'ı göster
        //   header.classList.remove('header--hidden');
        // }
      } else {
        // Threshold'un altında - header'ı normal haline getir
        if (isHeaderFixed) {
          header.classList.remove('header--fixed', 'header--hidden');
          document.body.style.paddingTop = '0';
          isHeaderFixed = false;
        }
      }
      
      lastScrollTop = scrollTop;
    };

    // Throttle fonksiyonu - performans için
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    // Event listener'ları ekle
    window.addEventListener('scroll', throttledHandleScroll, { passive: true });
    
    // Sayfa yüklendiğinde mevcut scroll pozisyonunu kontrol et
    window.addEventListener('load', () => {
      handleScroll();
    });

    // Resize event'inde header yüksekliğini güncelle
    window.addEventListener('resize', () => {
      const newHeaderHeight = header.offsetHeight;
      if (isHeaderFixed) {
        document.body.style.paddingTop = `${newHeaderHeight}px`;
      }
    });
  };

  const subMenu = () => {
    const subMenu = document.querySelectorAll('.main-menu .sub-item');
    const subMenuBg = document.querySelector('.header-shadow');
    if(subMenu.length > 0){
      subMenu.forEach(item => {
        item.addEventListener('mouseenter', () => {
          item.querySelector('.sub-menu').classList.add('active');
          subMenuBg.classList.add('active');
        });
        item.addEventListener('mouseleave', () => {
          item.querySelector('.sub-menu').classList.remove('active');
          subMenuBg.classList.remove('active');
        });
      });
    }

    const mobileMenuSubItem = document.querySelectorAll('.header-mobile-menu .sub-item');
    if(mobileMenuSubItem.length > 0){
      mobileMenuSubItem.forEach(item => {
        item.addEventListener('click', () => {
          item.classList.toggle('active');
          item.querySelector('.sub-menu').classList.toggle('active');
        });
      });
    }

  }

  const fullScreenSearch = () => {
    const searchBtn = document.querySelectorAll('.main-search .search-btn, .header-mobile-menu-inner-top .search-btn');
    const fullScreenSearch = document.querySelector('.full-screen-search');
    const fullScreenSearchBg = document.querySelector('.full-screen-search-bg');

    searchBtn.forEach(btn => {
      btn.addEventListener('click', () => {
        fullScreenSearch.classList.add('active');
      });
    });

    fullScreenSearchBg.addEventListener('click', () => {
      fullScreenSearch.classList.remove('active');
    });
    const closeSearchBtn = document.querySelector('.full-screen-search .close-search-btn');
    if(closeSearchBtn){
      closeSearchBtn.addEventListener('click', () => {
        fullScreenSearch.classList.remove('active');
      });
    }

  }

  const mobileMenu = () => {
    const mobileMenuBtn = document.querySelector('.header-mobile-hamburger-menu');
    const mobileMenu = document.querySelector('.header-mobile-menu');
    if(mobileMenuBtn){
      mobileMenuBtn.addEventListener('click', () => {
        mobileMenuBtn.classList.toggle('active');
        mobileMenu.classList.toggle('active');
      });
    }

  }

  const mobileMenuDetailPage = () => {
    const mobileMenuDetailPage = document.querySelectorAll('.detail-page-content-left-menu .detail-page-content-left-menu-item-title');
    if(window.innerWidth < 992){
      if(mobileMenuDetailPage.length > 0){
        mobileMenuDetailPage.forEach(item => {
          item.addEventListener('click', () => {
              item.classList.toggle('active');
            });
          });
      }
    }
  }

  const init = () => {
    if (isInitialized) {
      return;
    }
    isInitialized = true;
    fixedHeader();
    subMenu();
    fullScreenSearch();
    mobileMenu();
    mobileMenuDetailPage();
  };

  return {
    init,
  };
})();

export default header;
